import axios from "axios";

import {
  GET_CATEGORY_API,
  GET_CITY_API,
  GET_CITY_BY_STATE_ID_API,
  GET_STATE_API,
  GET_VENUE_API,
  GET_VENUE_BY_CITY_ID_API,
  GET_FEATURED_EVENT_API,
  GET_COUNT_API,
  GET_LATEST_BLOG_API,
  GET_SPONSOR_API,
  MAIN_API,
  GET_SEARCH_EVENT_API,
  GET_EVENT_BY_ID_API,
  GET_SESSION_BY_DAY_ID_API,
  REGISTER_API,
  VERIFY_EMAIL_API,
  GET_APP_SETTINGS_API,
  LOGIN_API,
  GOOGLE_USER_INFO_API,
  SOCIAL_LOGIN_API,
  CHECK_EMAIL_API,
  VERIFY_OTP_API,
  FORGOT_PASSWORD_API,
  SEND_MESSAGE_API,
  GET_ALL_BLOG_API,
  GET_BLOG_BY_ID_API,
  GET_CART_API,
  ADD_CART_API,
  REMOVE_CART_API,
  UPDATE_CART_API,
  APPLY_DISCOUNT_API,
  GET_DISCOUNT_API,
  CHECKOUT_API,
  GUEST_CHECKOUT_API,
  VERIFY_PAYMENT_API,
  GUEST_VERIFY_PAYMENT_API,
  GET_ORDER_API,
  POST_REVIEW_API,
  GET_ORDER_BY_ID_API,
  DOWNLOAD_TICKET_PDF_API,
  GET_SEARCH_SUGGESTION_API,
  GET_EVENT_SPONSOR_API,
  GET_POPUP_IMAGE_API,
} from "./apilist";
import { store, persistor } from "../redux/store/store";
import { LOGOUT_SUCCESS, LOGIN_SUCCESS } from "../redux/actions/action";
axios.interceptors.response.use(
  (response) => response,
  async (err) => {
    const reffreshToken = store.getState().auth.refreshToken;

    const originalRequest = err.config;

    if (err.status == 402 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = reffreshToken;

        const res = await axios.post(`${MAIN_API}/api/app/user/refreshToken`, { refreshToken });

        const accessToken = res.data.info.token;
        const newRefreshToken = res.data.info.refreshToken;
        const user = {
          id: res.data.info.user._id,
          email: res.data.info.user.email,
          name: res.data.info.user.name,
        };

        store.dispatch({ type: LOGIN_SUCCESS, payload: { accessToken, refreshToken: newRefreshToken, user } });

        // Retry the original request with the new token
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;

        return axios(originalRequest);
      } catch (refresherr) {
        console.error("err refreshing token:", refresherr);

        // You might want to redirect to login or handle the err in another way
      }
    }

    if (err.status === 423) {
      store.dispatch({ type: LOGOUT_SUCCESS });
      window.alert("Your session has expired. Please login again.");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

/* ---------------------------- ALL category API ---------------------------- */
export const getCategory = () => axios.get(MAIN_API + GET_CATEGORY_API);
/* ---------------------------- END category API ---------------------------- */
/* ---------------------------- ALL state API ---------------------------- */
export const getState = () => axios.get(MAIN_API + GET_STATE_API);
/* ---------------------------- END state API ---------------------------- */
/* ---------------------------- ALL city API ---------------------------- */
export const getCity = () => axios.get(MAIN_API + GET_CITY_API);
export const getCityByStateId = (data) => axios.post(MAIN_API + GET_CITY_BY_STATE_ID_API, data);
/* ---------------------------- END city API ---------------------------- */
/* ---------------------------- ALL venue API ---------------------------- */
export const getVenue = () => axios.get(MAIN_API + GET_VENUE_API);
export const getVenueByCityId = (data) => axios.post(MAIN_API + GET_VENUE_BY_CITY_ID_API, data);
/* ---------------------------- END venue API ---------------------------- */
/* ---------------------------- ALL event API ---------------------------- */
export const getFeaturedEvent = () => axios.get(MAIN_API + GET_FEATURED_EVENT_API);
export const getCount = () => axios.get(MAIN_API + GET_COUNT_API);
export const getSearchEvent = (data, page, limit) => {
  let url = MAIN_API + GET_SEARCH_EVENT_API + page;
  if (limit) {
    url += `&limit=${limit}`;
  }
  return axios.post(url, data);
};
export const getEventById = (id) => axios.get(MAIN_API + GET_EVENT_BY_ID_API + id);
export const getSessionByDayId = (data) => axios.post(MAIN_API + GET_SESSION_BY_DAY_ID_API, data);
export const getSearchSuggestion = (data) => axios.post(MAIN_API + GET_SEARCH_SUGGESTION_API, data);
export const getEventSponsor = (data) => axios.post(MAIN_API + GET_EVENT_SPONSOR_API, data);
/* ---------------------------- END event API ---------------------------- */
/* ---------------------------- ALL blog API ---------------------------- */
export const getLatestBlog = () => axios.get(MAIN_API + GET_LATEST_BLOG_API);
export const getAllBlog = (page = 1) => axios.get(MAIN_API + GET_ALL_BLOG_API + page);
export const getBlogById = (id) => axios.post(MAIN_API + GET_BLOG_BY_ID_API, { id });
/* ---------------------------- END blog API ---------------------------- */
/* ---------------------------- ALL sponser API ---------------------------- */
export const getSponsor = () => axios.get(MAIN_API + GET_SPONSOR_API);
/* ---------------------------- END sponser API ---------------------------- */
/* ---------------------------- ALL auth API ---------------------------- */
export const registerApi = (data) => axios.post(MAIN_API + REGISTER_API, data);
export const verifyEmailApi = (data) => axios.post(MAIN_API + VERIFY_EMAIL_API, data);
export const loginApi = (data) => axios.post(MAIN_API + LOGIN_API, data);
export const googleUserInfoApi = (token) =>
  axios.get(GOOGLE_USER_INFO_API, { headers: { Authorization: `Bearer ${token}` } });
export const socialLoginApi = (data) => axios.post(MAIN_API + SOCIAL_LOGIN_API, data);
export const checkEmailApi = (data) => axios.post(MAIN_API + CHECK_EMAIL_API, data);
export const verifyOtpApi = (data) => axios.post(MAIN_API + VERIFY_OTP_API, data);
export const forgotPasswordApi = (data) => axios.post(MAIN_API + FORGOT_PASSWORD_API, data);
export const getPopupImageApi = () => axios.get(MAIN_API + GET_POPUP_IMAGE_API);
/* ---------------------------- END auth API ---------------------------- */
/* ---------------------------- ALL appSettings API ---------------------------- */
export const getAppSettings = () => axios.get(MAIN_API + GET_APP_SETTINGS_API);
/* ---------------------------- END appSettings API ---------------------------- */
/* ---------------------------- ALL contact API ---------------------------- */
export const sendMessageApi = (data) => axios.post(MAIN_API + SEND_MESSAGE_API, data);
/* ---------------------------- END contact API ---------------------------- */
/* ---------------------------- ALL cart API ---------------------------- */
export const getCartApi = (token) => {
  return axios.get(MAIN_API + GET_CART_API, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const addCartApi = (data, token) => {
  return axios.post(MAIN_API + ADD_CART_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const removeCartApi = (data, token) => {
  return axios.post(MAIN_API + REMOVE_CART_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateCartApi = (data, token) => {
  return axios.post(MAIN_API + UPDATE_CART_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

/* ---------------------------- END cart API ---------------------------- */
/* ---------------------------- ALL discount API ---------------------------- */
export const applyDiscountApi = (data, token) => {
  return axios.post(MAIN_API + APPLY_DISCOUNT_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getDiscountApi = (token, eventIds) => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  let url = MAIN_API + GET_DISCOUNT_API;
  if (eventIds && eventIds.length > 0) {
    const params = new URLSearchParams();
    eventIds.forEach((id) => params.append("eventIds", id));
    url += `?${params.toString()}`;
  }
  return axios.get(url, { headers });
};
/* ---------------------------- END discount API ---------------------------- */
/* ---------------------------- ALL order API ---------------------------- */
export const createOrderApi = (data, token) => {
  return axios.post(MAIN_API + CHECKOUT_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const guestCreateOrderApi = (data) => {
  return axios.post(MAIN_API + GUEST_CHECKOUT_API, data);
};
export const verifyPaymentApi = (data, token) => {
  return axios.post(MAIN_API + VERIFY_PAYMENT_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const guestVerifyPaymentApi = (data) => {
  return axios.post(MAIN_API + GUEST_VERIFY_PAYMENT_API, data);
};
export const getOrderApi = (token) => {
  return axios.get(MAIN_API + GET_ORDER_API, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const postReviewApi = (token, data) => {
  return axios.post(MAIN_API + POST_REVIEW_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getOrderByIdApi = (id) => {
  return axios.post(MAIN_API + GET_ORDER_BY_ID_API, { id });
};
export const downloadTicketPdfApi = (id) => {
  return axios.post(MAIN_API + DOWNLOAD_TICKET_PDF_API, { id }, { responseType: 'blob' });
};

/* ---------------------------- END order API ---------------------------- */

export const fetchSetting = async () => {
  try {
    const response = await axios.get(MAIN_API + GET_APP_SETTINGS_API);
    return response.data.info;
  } catch (error) {
    console.error(error);
  }
};
